const fil = {
  name: "Табак",
  subMenu: [
    {
      subName: "Призначення табака",
      subList: [
        "Для самокруток",
        "Бля кальяну",
        "Для люльки",
        "Нюхальний табак",
      ],
    },
    {
      subName: "Бренд",
      subList: [
        "Бренд 1",
        "Бренд 2",
        "Бренд 4",
        "Бренд 5",
        "Бренд 6",
        "Бренд 7",
      ],
    },
    {
      subName: "Міцність",
      subList: [
        "М’який",
        "Середньо-м’який",
        "Середній",
        "Середньо-міцний",
        "Міцний",
      ],
    },
    {
      subName: "Країна виробництва",
      subList: ["Країна 1", "Країна 2", "Країна 3", "Країна 4", "Країна 5"],
    },
  ],
};
const fl = { ...fil };
fl.name = "Витратники";
const f = { ...fil };
f.name = "Сигари";
const f1 = { ...fil };
f1.name = "Аксесуари";

export const menuItems = [fil, fl, f, f1];
